import React from 'react'
import Header from './component/header/Header'
import Nav from './component/nav/Nav'
import About from './component/about/About'
import Experience from './component/experience/Experience'
import Expertise from './component/expertise/Expertise'
import Service from './component/services/Services'
import Portifolio from './component/portifolio/Portifolio'
import Testimonials from './component/testimonials/Testimonials'
import Contact from './component/contact/Contact'
import Footer from './component/footer/Footer'
import ThemeToggle from './component/ThemeToggle'
import Loader from './component/loader/Loader'
// import Timeline from './component/timeline/Timeline'
import EasterEggs from './component/eastereggs/EasterEggs'
import ParticleField from './component/3d/ParticleField'
import { ParticlesBackground, ClickSpark } from './component/reactbits'

const App = () => {
  return (
   <>
   <Loader />
   <ParticleField particleCount={80} color="#ff6b35" />
   <ParticlesBackground 
     particleCount={40} 
     particleColor="#ff6b35" 
     speed={0.5}
   />
   <ClickSpark color="#ff6b35" particleCount={8} />
   <EasterEggs />
   <ThemeToggle />
   <Header />
   <Nav />
   <About />
   <Expertise />
   <Experience />
   {/* <Timeline /> */}
   <Service />
   <Portifolio />
   <Testimonials />
   <Contact />
   <Footer />
   </>
  ) 
}

export default App
